const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "대상년도", "작업계획서 첨부"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let year = search.year;
    conditions.push({ key: "header.year", operator: "=", value: `${year}` });

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "부서명",
        key: "body.부서명",
      },
      {
        name: "작업명",
        key: "body.작업명",
      },
      {
        name: "작업지휘자",
        key: "body.작업지휘자",
      },
      {
        name: "신호방법",
        key: "body.신호방법",
      },
      {
        name: "운반장비",
        key: "body.운반장비",
      },
      {
        name: "작업계획서 첨부",
        key: "body.작업계획서첨부",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0:
          return postContent.header.year; // 대상년도
        case 1:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2:
          return func.getContent(value).부서명; // 부서명
        case 3:
          return func.getContent(value).작업명; // 작업명
        case 4:
          return func.getContent(value).작업지휘자; // 작업지휘자
        case 5:
          let 신호방법 = func.getContent(value).check신호방법;

          // 정렬
          let 순서 = ["수신호", "무선", "기타"];
          신호방법 = 순서.filter((item) => 신호방법.includes(item));

          신호방법 = 신호방법.map((item) => {
            if (item === "기타") return `기타(${func.getContent(value).신호방법기타})`;
            else return item;
          });

          return 신호방법.join(", "); // 신호방법
        case 6:
          return func.getContent(value).운반장비; // 운반장비
        case 7: {
          // 작업계획서첨부
          const file = func.getContent(value).작업계획서첨부;
          return {
            type: "docs",
            file: file,
          };
        }
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
